<!-- Main calculator card -->
<div class="savings-hero__card">

  <!-- Animated savings number -->
  <div class="savings-hero__savings-display">
    <div class="savings-hero__savings-amount">
      {{ displaySavings() | formatDollars }}
    </div>
    <div class="savings-hero__savings-label">
      estimated savings with
      <strong>{{ selectedPlan().name }}</strong>
      vs. traditional 3% agent ·
      <strong>{{ savingsPct() }}% less</strong>
    </div>
  </div>

  <!-- Price slider -->
  <div class="savings-hero__slider-wrap">
    <div class="savings-hero__slider-labels">
      <label class="savings-hero__slider-label">Home Purchase Price</label>
      <span class="savings-hero__price-display">{{ homePrice() | formatDollars }}</span>
    </div>
    <div class="savings-hero__slider-track">
      <div
        class="savings-hero__slider-fill"
        [style.width.%]="sliderPct()"
      ></div>
      <input
        type="range"
        class="savings-hero__slider-input"
        [min]="HOME_PRICE_MIN"
        [max]="HOME_PRICE_MAX"
        [step]="HOME_PRICE_STEP"
        [value]="homePrice()"
        (input)="onSliderChange($event)"
      />
      <div
        class="savings-hero__slider-thumb"
        [style.left.%]="sliderPct()"
      ></div>
    </div>
    <div class="savings-hero__slider-ticks">
      <span>$200K</span><span>$850K</span><span>$1.5M</span>
    </div>
  </div>

  <!-- Cost comparison -->
  <div class="savings-hero__comparison">
    <div class="savings-hero__comparison-cell savings-hero__comparison-cell--traditional">
      <div class="savings-hero__comparison-cell-label">Traditional Agent (3%)</div>
      <div class="savings-hero__comparison-cell-amount savings-hero__comparison-cell-amount--red">
        {{ traditionalCost() | formatDollars }}
      </div>
      <div class="savings-hero__comparison-cell-sub">
        3% of {{ homePrice() | formatDollars }}
      </div>
    </div>

    <div class="savings-hero__vs">VS</div>

    <div class="savings-hero__comparison-cell savings-hero__comparison-cell--shark">
      <div class="savings-hero__comparison-cell-label"><img ngSrc="/icons/homeshark-icon.svg" height="25" width="25"
                                                            alt=""/> {{ selectedPlan().name }}
      </div>
      <div class="savings-hero__comparison-cell-amount savings-hero__comparison-cell-amount--cyan">
        {{ sharkCost() | formatDollars }}
      </div>
      <div class="savings-hero__comparison-cell-sub">est. all-in cost</div>
    </div>
  </div>

  <!-- Plan selector tabs -->
  <div class="savings-hero__tabs">
    @for (plan of plans(); track plan.id) {
      <button
        class="savings-hero__tab"
        [class.savings-hero__tab--active]="selectedPlanId() === plan.id"
        (click)="selectPlan(plan.id)"
      >{{ plan.name }}
      </button>
    }
  </div>
</div>
